import type { UserDataLogRocketType } from '../logRocket';
import { getFullName } from '../../react/_util/getFullName';

interface AuthUser {
  email: string | null;
  phone: string | null;
  givenName: string | null;
  familyName: string | null;
  key: string;
}

interface WindowExtensions {
  githubInfo?: { commit?: string };
  circleCiInfo?: { buildLink?: string };
  browserInfo?: { name?: string; version?: string };
  osInfo?: { name?: string; version?: string };
  buildInfo?: string;
  resolution?: string;
  ramInfo?: string;
  locale?: string;
}

export const getSessionData = (authUser: AuthUser): UserDataLogRocketType => {
  const {
    githubInfo = {},
    circleCiInfo: circleCi = {},
    browserInfo = {},
    osInfo = {},
    buildInfo = '',
    resolution = '',
    ramInfo = '',
    locale = '',
  } = window as unknown as WindowExtensions;

  const { email, phone, givenName, familyName, key } = authUser;

  const githubLink = githubInfo.commit || '';
  const circleCiInfo = circleCi.buildLink || '';
  const browserName = browserInfo.name || '';
  const browserVersion = browserInfo.version || '';
  const osName = osInfo.name || '';
  const osVersion = osInfo.version || '';

  const name = getFullName(authUser);

  return {
    key,
    name,
    // LogRocket traits must be strings, numbers or booleans; null is rejected.
    email: email ?? '',
    phone: phone ?? '',
    givenName: givenName ?? '',
    familyName: familyName ?? '',

    circleCiInfo,
    buildInfo,
    resolution,
    ramInfo,
    locale,
    githubLink,
    browserName,
    browserVersion,
    osName,
    osVersion,
  };
};
